import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { LayoutGrid } from 'lucide-react';

import { useMyNineBoxApi } from './config';

// Task 34 — Çalışan self-view (/talent/my-ninebox, self — [Authorize]-only BE ucu,
// modül kapısı YOK). TalentSettings.EmployeeCanSeeNineBox==false veya TD aboneliksiz
// tenant → 409 (skipErrorToast'lı) → jenerik toast YERİNE bu sayfanın kendi bilgi
// boş-durumu (bkz. config/index.js useMyNineBoxApi, MyPeriodResultsPage deseniyle aynı).
// Layout'un Main'i zaten 16px 16px padding veriyor — sayfa kendi ekstra padding'ini
// eklemez; max-width dar tek-sütun self-servis görünümü için korunuyor.
const Container = styled.div`
  max-width: 560px;
`;

const PageTitle = styled.h2`
  margin: 0 0 20px;
  font-size: ${({ theme }) => theme.metrics.font.size.xl};
  color: ${({ theme }) => theme.colors.text.primary};
`;

const Card = styled.div`
  background: ${({ theme }) => theme.colors.surface.card};
  border: 1px solid ${({ theme }) => theme.colors.surface.border};
  border-radius: 10px;
  overflow: hidden;
`;

const Centered = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 60px 24px;
  text-align: center;
`;

const EmptyIconWrap = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.bgColor};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.text.dark.little};
`;

const EmptyText = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  color: ${({ theme }) => theme.colors.text.dark.little};
  max-width: 420px;
`;

const PlacementCard = styled.div`
  padding: 24px;
`;

const CellLabel = styled.div`
  font-size: 22px;
  font-weight: ${({ theme }) => theme.metrics.font.weight.bold};
  color: ${({ theme }) => theme.colors.primary.main};
  margin-bottom: 4px;
`;

const ProcessLabel = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  color: ${({ theme }) => theme.colors.text.dark.little};
  margin-bottom: 18px;
`;

const ScoreGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 18px;
`;

const ScoreField = styled.div``;

const ScoreLabel = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.dark.little};
  margin-bottom: 4px;
`;

const ScoreValue = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.md};
  font-weight: ${({ theme }) => theme.metrics.font.weight.semiBold};
  color: ${({ theme }) => theme.colors.text.primary};
`;

const StrategyHint = styled.div`
  padding: 12px 14px;
  background: ${({ theme }) => theme.colors.bgColor};
  border-radius: 6px;
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  color: ${({ theme }) => theme.colors.text.primary};
  line-height: 1.5;
`;

export default function MyNineBoxPage() {
  const { t } = useTranslation();
  const {
    placement, processName, notAvailable, fetching,
  } = useMyNineBoxApi();

  // notAvailable (abonelik yok / self-view kapalı) VE "placement yok" (henüz tamamlanmış
  // süreç veya kendi hücren yok) — ikisi de kullanıcı için aynı jenerik boş-duruma düşer
  // (bkz. config/index.js useMyNineBoxApi yorumu).
  const showEmpty = !fetching && (notAvailable || !placement);

  return (
    <Container>
      <PageTitle>{t('performance.ninebox.my.title')}</PageTitle>

      {fetching && (
        <Card><Centered><EmptyText>{t('common.loading')}</EmptyText></Centered></Card>
      )}

      {showEmpty && (
        <Card>
          <Centered>
            <EmptyIconWrap><LayoutGrid size={26} /></EmptyIconWrap>
            <EmptyText>{t('performance.ninebox.my.noPlacement')}</EmptyText>
          </Centered>
        </Card>
      )}

      {!fetching && !showEmpty && placement && (
        <Card>
          <PlacementCard>
            <CellLabel>{t(`performance.ninebox.cell.${placement.cellKey}`)}</CellLabel>
            {processName && (
              <ProcessLabel>{t('performance.ninebox.process.title')}: {processName}</ProcessLabel>
            )}
            <ScoreGrid>
              <ScoreField>
                <ScoreLabel>{t('performance.ninebox.performance')}</ScoreLabel>
                <ScoreValue>{placement.performanceScore != null ? placement.performanceScore.toFixed(2) : '-'}</ScoreValue>
              </ScoreField>
              <ScoreField>
                <ScoreLabel>{t('performance.ninebox.potential')}</ScoreLabel>
                <ScoreValue>{placement.potentialScore != null ? placement.potentialScore.toFixed(2) : '-'}</ScoreValue>
              </ScoreField>
            </ScoreGrid>
            {placement.cellKey && (
              <StrategyHint>{t(`performance.ninebox.strategy.${placement.cellKey}`)}</StrategyHint>
            )}
          </PlacementCard>
        </Card>
      )}
    </Container>
  );
}
